export default "__VITE_ASSET__6kt_FJIX__"